import axios from "axios";
import { store } from "../store";
import url from "./base-url";
import browser from "./browser-check";
import { Message } from "element-ui";
import Alert from "../components/alert/alert.js";
axios.defaults.timeout = 30000;
axios.defaults.baseURL = url.base;
axios.defaults.withCredentials = true;
axios.defaults.headers = {
  VersionType: "2",
};
// http request 拦截器
axios.interceptors.request.use(
  (config) => {
    if (browser.isIE() && config.method == "get") {
      if (config.url.indexOf("?") == -1) {
        config.url = config.url + "?random=" + Math.random();
      } else {
        config.url = config.url + "&random=" + Math.random();
      }
    }
    config.headers.isqlw = store.state.inQlw;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status == 401) {
      window.location.href = "/login";
    }
    if (error.response.status == 400) {
      Alert.info({
        content: error.response.data,
        duration: 3000,
        status: "error",
      });
    }
    if (error.response.status == 403) {
      if (store.state.inQlw) {
        window.location.href = "/403?appid=1";
      } else {
        window.location.href = "/403";
      }
    }
    return Promise.reject(error);
  }
);
export default axios;
